module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-800.df1c0adf.svg";